import { render, staticRenderFns } from "./QuizSlides.vue?vue&type=template&id=057f0696"
import script from "./QuizSlides.vue?vue&type=script&lang=js"
export * from "./QuizSlides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports